<script>
import { mapActions } from "vuex";
import i18n from "@/plugins/i18n";

export default {
  data() {
    return {
      formData: {},
      registerActive: false,
      showPassword: false,
      firstName: "",
      surname: "",
      userID: "",
    };
  },
  computed: {
    isButtonDisabled() {
      if (this.formData.userpwd != this.formData.userpwd2) {
        return true
      } else if (!this.formData.userpwd || !this.formData.userpwd2) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    ...mapActions("settings", ["getUserToken", "postUserToken", "registerToken", "resetPassword"]),
    getUserInfo() {
      let temp = window.location.search.split("?token=");
      this.token = temp[1];
      let params = {
        token: this.token,
      };
      this.getUserToken(params)
        .then((res) => {
          this.firstName = res.data[0].firstname;
          this.surname = res.data[0].surname;
          this.userID = res.data[0].user_id;
        })
        .catch(({ response }) => {
          // this.$router.push("/login");
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        });
    },
    postUserInfo() {
      let temp = window.location.search.split("?token=");
      this.token = temp[1];
      let params = {
        token: this.token,
        userpwd: this.formData.userpwd,
      };
      this.postUserToken(params)
        .then((res) => {
          this.$router.push("/login");
          this.$toast.open({
            message: this.$parseResMessage(res.data.messageName),
            type: "success",
            duration: 5000,
            dismissible: true,
          });
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        });
    },
    userToken() {
      const params = {
        token: window.location.search.split("?token="),
      }
      this.registerToken(params)
    },
    toLogin() {
      this.$router.push('/login')
    },

    resetUserPass() {
      const params = {
        user_id: this.userID,
        password: this.formData.userpwd
      }
      this.resetPassword(params)
        .then((res) => {
          this.$router.push("/login");
          this.$toast.open({
            message: this.$parseResMessage(res.data.messageName),
            type: "success",
            duration: 5000,
            dismissible: true,
          });
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        });
    }
  },
  created() {
    this.getUserInfo();
  },
  watch: {},
};
</script>

<template>
  <div class="login-page">
    <div class="login-container">
      <div class="form-container">
        <div class="form-content">

          <div class="form-card" style="background-color: transparent">
            <img style="padding: 25px" src="/images/sustainfinity-logo.png" alt="sustainfinity-logo" />
            <div style="text-align: center">
              <p style="font-size: 200%; color: #61a60e">
                {{ $t("registerForm.hello") }} {{ this.firstName }}
                {{ this.surname }} !
              </p>
            </div>
            <p style="font-size: 120%; text-align: center;">
              {{ $t("registerForm.cartTitle") }}
            </p>
            <form @submit.prevent autocomplete="on">
              <div class="input-wrapper">
                <input v-model="formData.userpwd" :type="showPassword ? 'text' : 'password'" class="input-field"
                  :placeholder="$t('registerPass.password')" required autocomplete="new-password" />
                <div class="password-icon-container">
                  <i class="fa-regular fa-eye show-password-icon" @click="showPassword = !showPassword"
                    v-if="showPassword == false"></i>
                  <i class="fa-regular fa-eye-slash show-password-icon" @click="showPassword = !showPassword"
                    v-if="showPassword == true"></i>
                </div>
              </div>
              <br />
              <div class="input-wrapper">
                <input v-model="formData.userpwd2" :type="showPassword ? 'text' : 'password'" class="input-field"
                  :placeholder="$t('registerPass.password_again')" required autocomplete="new-password" />
                <div class="password-icon-container">
                  <i class="fa-regular fa-eye show-password-icon" @click="showPassword = !showPassword"
                    v-if="showPassword == false"></i>
                  <i class="fa-regular fa-eye-slash show-password-icon" @click="showPassword = !showPassword"
                    v-if="showPassword == true"></i>
                </div>
              </div>
              <br />
              <button class="submit-button" @click="resetUserPass()" :disabled="isButtonDisabled"> {{
                $t("registerForm.save") }}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.container {
  position: fixed;
  top: 52%;
  left: 75%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 75vh;
  max-width: 400px;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.form-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
}

.form-content {
  width: 75vh;
  max-width: 500px;
  padding: 20px;
  border-radius: 10px;

}

.form-card {
  padding: 25px;
  border-radius: 5px;
  text-align: center;
  border: 2px solid rgb(214, 212, 212);
  max-width: 400px;
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 400px;
  margin: auto;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  padding: 5px;
  margin-bottom: 5px;
}

.input-field {
  width: 100%;
  padding: 10px;
  border: none;
  font-size: 16px;
  padding-right: 35px;
  border-radius: 5px;
  border: 1px solid transparent;
  transition: all 0.3s ease-in-out;
}

.input-field:focus {
  border: 1px solid #0383ab;
  box-shadow: 0 0 5px 2px rgba(116, 177, 243, 0.973);

}

.eye-button {
  position: absolute;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  font-size: 16px;
  top: 50%;
  transform: translateY(-50%);
}

.submit-button {
  width: 100%;
  background-color: #61a60e;
  color: white;
  padding: 12px;
  border: 1px solid transparent;
  border-radius: 5px;
  cursor: pointer;
  font-size: large;
  text-align: center;
  transition: background-color 0.3s ease;
  text-transform: uppercase;
  font-weight: bold;
}

.submit-button:hover {
  background-color: #229863;
}

.submit-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
  border: 1px solid #28a745;
}

.password-icon-container {
  position: absolute;
  z-index: 10;
  right: .75em;
  top: 50%;
  transform: translateY(-50%);
}

.show-password-icon:hover {
  cursor: pointer;
  filter: brightness(125%);
  z-index: 99;
}
</style>
